import { atom } from 'jotai'

const InstructorView = {
  groupSessions: atom([]),
  privateSessions: atom([]),
  loading: atom(false),
  error: atom(null),
}

const InstructorViewReset = atom(null, (get, set) => {
  set(InstructorView.groupSessions, [])
  set(InstructorView.privateSessions, [])
  set(InstructorView.loading, true)
  set(InstructorView.error, null)
})

InstructorView.reset = InstructorViewReset

export { InstructorView as InstructorViewAtom }
